<template>
	<div>
		<div><slot name="label" /></div>
		<GenericSelector
			:value="value"
			@input="val => $emit('input', val)"
			:options="options"
			:showOptions="showOptions"
			:loading="loading"
			:displayCb="displayCb"
            :allowBadges="true"
            :badgeCb="badgeCb"
            :clickCb="clickCb"
		>
			<template v-slot:unselectedHeader>
				<div class="d-flex flex-row flex-wrap align-items-center mt-2">
                    <SearchBar v-if="showOptions" v-model="search" :debounce="false" class="mb-2 mr-2" />
                    <SelectInput
                        v-if="showOptions"
                        v-model="groupFilter"
                        :options="groups"
                        optionValue="id"
                        optionLabel="title"
                        :label="$t('select-a-group')"
                        :srOnly="true"
                        :nullLabel="$t('all-groups')"
                        class="mb-2 mr-2"
                        style="min-width: 160px"
                    />

                    <button
                        type="button"
                        @click="toggleEdit"
                        class="btn ml-auto mb-2"
                        :class="showOptions ? 'btn-secondary' : 'btn-primary'"
                        v-if="!viewOnly"
                    >
                        <b-icon 
                            v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
                    </button>
                </div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SelectInput from '../Inputs/SelectInput.vue';
import SearchBar from '../Table/SearchBar.vue';
import LearningOutcomes from 'src/modules/learningoutcomes.js'


export default {
	components: {
		GenericSelector,
		SearchBar,
		SelectInput
	},
	props: {
		value: Array,
        viewOnly: Boolean,
        defaultGroups: {
            type: Array,
            default: () =>[]
        },
        defaultlearningoutcomes: {
            type: Array,
            default: () =>[]
        }
    },
	data() {
		return {
			learningoutcomes: [],
            groups:[],
			groupFilter: null,
			loading: true,
			showOptions: false,
			search: ''
		};
	},
	mounted() {
        this.learningOutcomes = new LearningOutcomes();
        
        this.learningOutcomes.list()
        .then((res) => this.learningoutcomes = res.results );
       
        this.learningOutcomes.listGroups()
        .then((res) => this.groups = res.results)
        .finally(() => this.loading = false);
    } ,
	methods: {
        displayCb(item){
        	if(item.code){
            	return `${item.code}: ${item.title}`
            }
            return item.title;
        },
        badgeCb(item){
            if(item.learningoutcomegroup_id){
                let group = this.groups.filter(el => el.id === item.learningoutcomegroup_id)[0];
                return group ? group.title : null;
            } 
        },
        toggleEdit(){
            this.showOptions = !this.showOptions; 
            this.$emit('doneEditing', !this.showOptions)
        },
        clickCb(item){
            if(item.id) this.$router.push(`/curriculum-mapping/learning-outcomes/edit/${item.id}`)
        }
	},
	computed: {
		options() {
			return this.learningoutcomes.filter(outcome => outcome.title.toLowerCase().includes(this.search.toLowerCase())
				&& (!this.groupFilter || this.groupFilter == outcome.learningoutcomegroup_id))
		}
	}
};
</script>
